"use strict";

define('rs/form/formobjects/attach/attach.formobject',['rs/form/formobjects/base.formobject', 'rs/form/formobjects/attach/attach.formobject.view'], function (BaseFormObject, AttachFormObjectView) {
  var AttachFormObject = BaseFormObject.extend({
    propertiesDefinitions: ['name', 'required', 'label', 'text', 'description', 'helpText'],
    properties: ['ariaControlsId'],
    isAttachmentBtn: true,
    linksDefinitions: ['link.attach'],
    initialize: function initialize() {
      this._super.apply(this, arguments);
      this.setAriaControlsId('fo-' + this.getId());
    },
    setupView: function setupView() {
      this.setView(new AttachFormObjectView());
    },
    isCommentable: function isCommentable() {
      return true;
    },
    checkValue: function checkValue() {
      var attachments = this.getAttachments();
      if (this.getFormController().isPreviewMode()) {
        return true;
      } else {
        return attachments.length;
      }
    },
    getValue: function getValue() {
      return JSON.stringify(this.getAttachments());
    },
    displayedDidChange: function displayedDidChange() {
      this._super.apply(this, arguments);
      this.refreshValidity();
    },
    parentDisplayDidChange: function parentDisplayDidChange() {
      this._super.apply(this, arguments);
      this.refreshValidity();
    },
    getAttachController: function getAttachController() {
      return this.getDependentsByProperty('attach')[0];
    },
    getAttachments: function getAttachments() {
      var ctrlr = this.getAttachController();
      return ctrlr && ctrlr.getValue() || [];
    },
    requestAttachmentRemove: function requestAttachmentRemove(index) {
      if (!this.isReadOnly()) {
        this.getAttachController().removeDocumentAtIndex(index);
      }
    },
    isLinked: function isLinked() {
      return !!this.getAttachController();
    },
    refreshAttachments: function refreshAttachments() {
      if (this.isLinked()) {
        var hasMultiple = this.getAttachController().getHasMultiple(),
          attachments = this.getAttachments();
        this.getView().setAttachments(attachments);
        this.refreshValidity();
        if (this._initialAttachments) {
          this.valueDidChange();
        } else {
          this._initialAttachments = true;
        }
      }
    },
    getTemplateProperties: function getTemplateProperties() {
      var properties = this._super(),
        attachController = this.getAttachController();
      if (attachController) {
        properties.samples = attachController.getSamples();
      }
      return properties;
    },
    addNewDependent: function addNewDependent(property) {
      this._super.apply(this, arguments);
      if (property == "attach") {
        this.getView().refresh();
      }
    },
    removeDependent: function removeDependent(property) {
      this._super.apply(this, arguments);
      if (property == "attach") {
        this.getView().refresh();
      }
    },
    getAttachmentModalOptions: function getAttachmentModalOptions() {
      if (this.getAriaControlsId()) {
        return {
          ariaControls: this.getAriaControlsId()
        };
      }
    },
    requestAttachDocument: function requestAttachDocument() {
      var attachment = this.getAttachController();
      var modalOptions = this.getAttachmentModalOptions();
      if (attachment) {
        this.getFormController().requestAttachmentAction(attachment, modalOptions);
      }
    },
    getCompareValue: function getCompareValue() {
      var thisValue = this.getValue();
      if (thisValue[0] === "\"") {
        thisValue = thisValue.substr(1, thisValue.length - 2);
        thisValue = thisValue.replace(/\\/g, "");
      }
      var attachedObjects = JSON.parse(thisValue);
      var mapped = attachedObjects.map(function (value) {
        if (value.url) {
          return value.url;
        } else if (value.documentHash) {
          return value.documentHash;
        } else {
          return value;
        }
      });
      return JSON.stringify(mapped);
    }
  }, {
    getTypeString: function getTypeString() {
      return 'AttachButton';
    },
    propertiesDefinitions: _.extend({}, BaseFormObject.propertiesDefinitions, {
      'link.attach': {
        type: 'attach',
        displayName: 'Attaches'
      }
    })
  });
  return AttachFormObject;
});

